<div class="myvf-sticky-overlay">
  <div class="myvf-sticky" #dialog>
    <ng-content></ng-content>
  </div>
</div>
